import React, { Fragment, useRef, useEffect } from 'react';
import styles from './fir-upload.module.scss';
import {
    additionComments,
    changeProgress,
    resetSelectedProblems,
    uploadedFilesRedux,
} from '../../redux/actions/selfserveActions';
import { useDispatch } from 'react-redux';
import { connect } from 'react-redux';
import UITextArea from "../common/ui-components/input/UITextArea"
import Button from '../common/ui-components/input/Button';
import commonStyles from '../../styles/modules/components/SelfServe/phone-input-step.module.scss';
import UploadDocuments from '@/components/UI/UploadDocuments';

interface ReduxStateProps {
    selfserveReducer: any,
}

interface MainProps {
    setPageLoading: (data: Boolean) => void
}

type Props = ReduxStateProps & MainProps;

const FirUpload = (props: Props) => {
    const dispatch: any = useDispatch();
    const [comment, setComment] = React.useState('');
    const document_data = props.selfserveReducer.serviceRequests[0].selected_cover?.cover_details[0]?.upload_document_data || ''
    const handleButton = () => {
        dispatch(additionComments(comment))
        dispatch(changeProgress(7, true));
    }
    const previousButton = () => {
        dispatch(changeProgress(4, true));
    }
    const commentsRef = useRef<HTMLDivElement | null>(null); // Specify the correct type

    const scrollToComments = (data, files) => {
        if (commentsRef.current) {
            commentsRef.current.scrollIntoView({ behavior: 'smooth' });
        }
        dispatch(uploadedFilesRedux(files))
    };
    const uploadSectionRef = useRef(null);
    return (
        <Fragment>
            <div className={styles.container}>
                <div className={styles.heading_section}>
                    <div className={styles.title}>{document_data.document_title} <span>{document_data.document_sub_title}</span></div>
                    <div className={styles.note}>Important: <span>{document_data.customer_message}</span></div>
                </div>
                <div ref={uploadSectionRef} className={styles.upload_doc_section}>
                    <p>Upload file format .pdf .jpg, .jpeg, .png (Max size 10MB)</p>
                    <UploadDocuments supportedFormats={["jpeg", "jpg", "png", "pdf"]} refr={commentsRef} outsideClickRef={uploadSectionRef} handlePostUpload={scrollToComments} presignedUrlType="fir_copy" docType="fir_image" name="FirCopy" files={props.selfserveReducer.uploadedDocuments} file_path={document_data.document_s3_path} requiredField={true}/>
                </div>
                <div className={styles.comments_section}>
                    <div className={styles.comment_heading}>Comments <span>(optional)</span></div>
                    <UITextArea
                        value={comment}
                        label='Enter Comments'
                        onChange={(e) => { setComment(e.target.value) }}
                        id="comment"
                        className={styles.formdiv__textfieldlong}
                        minHeight={60}
                        characterLimit={50}
                    />
                    <p>(Maximum word limit is 50 characters)</p>
                </div>
                <div className={commonStyles.button_actions_sticky} data-varient='sticky'>
                    {
                        <Button
                            disabled={props.selfserveReducer.landed_on_page === 'issues'}
                            className={commonStyles.cart_btn}
                            text={'Previous'}
                            variant='secondary'
                            onClick={() => {
                                previousButton()
                            }}
                        />
                    }
                    <Button
                        disabled={!props.selfserveReducer.uploadedDocuments.length}
                        className={commonStyles.cart_btn}
                        text={'Next'}
                        variant='primary'
                        onClick={() => { handleButton() }}
                    />

                </div>
            </div>
        </Fragment>
    )
}

const mapStateToProps = (state: any) => {
    return {
        selfserveReducer: state.selfserveReducer,
    }
}

export default connect<ReduxStateProps>(mapStateToProps)(FirUpload);
